import { gql } from "@apollo/client";

// GraphQL query for listing Google Drive files
export const LIST_GOOGLE_DRIVE_FILES = gql`
  query ListGoogleDriveFiles($input: ListDriveFilesInput) {
    listGoogleDriveFiles(input: $input) {
      id
      name
      mimeType
      size
      iconLink
      webViewLink
    }
  }
`;

// GraphQL query for getting file content
export const GET_GOOGLE_DRIVE_FILE_CONTENT = gql`
  query GetGoogleDriveFileContent($input: GetDriveFileInput!) {
    getGoogleDriveFileContent(input: $input)
  }
`;
